<template>
    <a-popover v-model="attributePickerVisible" trigger="click" placement="left" :overlayClassName="'no-padding'">
        <div slot="content">
            <AttributePicker :default-selected="null" :pick="onAttributePicked" :filter-mode="true" />
        </div>
        <div class="message-filter-adder" :class="{ 'd-none': !visible }">
            <span class="icon material-icons"> filter_alt </span>
            <span>{{ $t("chatbotv2.addFilter") }}</span>
        </div>
    </a-popover>
</template>

<script>
import log2 from "../../../../../../utils/log2";
import _ from "lodash";
import AttributePicker from "../pickers/AttributePicker";
import { generateRandomId } from "../../../../../../utils/session";
import CONFIG from "../../../../../../config/config";
import systemAttributes from "../../../utils/systemAttributes";

const log = log2("MessageDelaySlider");
export default {
    name: "MessageFilterAdder",
    components: {
        AttributePicker,
    },
    props: {
        onFilterAdded: {
            type: Function,
            default: () => {},
        },
        visible: {
            type: Boolean,
            default: true,
            required: false,
        },
    },
    computed: {},
    data() {
        return {
            active: false,
            attributePickerVisible: false,
        };
    },
    methods: {
        onAttributePicked(attribute) {
            const id = generateRandomId();
            let value = 0;
            const foundAttr =
                systemAttributes.find((x) => x.value === attribute) ||
                CONFIG.AKINON.attributes.find((x) => x.value === attribute) ||
                CONFIG.IDEASOFT.attributes.find((x) => x.value === attribute) ||
                CONFIG.PROBEL.attributes.find((x) => x.value === attribute);
            let rule = _.get(foundAttr, "defaultOperator", "equal");
            value = _.get(foundAttr, "defaultFilterValue", value);
            const item = {
                id,
                rule,
                attribute,
                value,
            };
            this.attributePickerVisible = false;
            log("onAttributePicked", item);
            this.onFilterAdded(item);
        },
    },
    watch: {},
};
</script>

<style lang="scss">
.message-filter-adder {
    align-items: center;
    background: #686ad3;
    border-radius: 13px;
    cursor: pointer;
    display: flex;
    height: 26px;
    padding: 0 9px;
    transition: all 0.3s;
    //grid-column-gap: 10px;
    //display: grid;
    //grid-template-columns: minmax(0, 1fr) 90px;
    //width: 100%;

    &:hover {
        opacity: 0.8 !important;
    }

    span {
        color: #fff;
        font-size: 15px;
        font-weight: 600;
        line-height: 19px;
    }

    .icon {
        color: #fff;
        margin-right: 9px;
    }
}
</style>
